/**
 * @module DefaultTemplate
 * @description
 */
import React, { FC } from 'react';

interface Props {
  header: JSX.Element;
  footer: JSX.Element;
  title: string;
  hero?: JSX.Element;
  children: JSX.Element;
}

const Template: FC<Props> = ( { ...props } ) => {
  const {
    header,
    footer,
    title,
    hero,
    children
  } = props;
  return (
    <>
      { header }

      <div id="primary" className="content-area">
        <main id="content" className="site-content" role="main" tabIndex={ -1 }>
          <article id="post-id" className="hentry entry page-entry">
            <header className="entry-header" suppressHydrationWarning={ true }>
              <h1 className="entry-title screen-reader-text">{ title }</h1>
              { hero }
            </header>

            <div className="entry-content" suppressHydrationWarning={ true }>
              { children }
            </div>
          </article>
        </main>
      </div>{ /* <!-- .content-area --> */ }

      { footer }
    </>
  );
};

Template.displayName = 'DefaultTemplate';

export default Template;
